export const mapBackendToForm = (data, uhid_no) => {
  if (!data || !data.assessments || data.assessments.length === 0) return null;
  
  const latest = data.assessments[0];
  
  return {
    existingId: latest.id,
    patientData: {
      ip_no: latest.ip_no || "",
      uhid_no: latest.uhid_no || uhid_no,
      patient_name: latest.patient_name || "",
      age: latest.age || "",
      sex: latest.sex || "",
      ward_no: latest.ward_no || "",
      room_no: latest.room_no || "",
      assessment_date: latest.assessment_date
        ? new Date(latest.assessment_date).toISOString().split('T')[0]
        : '',
      anesthesiologist: latest.anesthesiologist || "",
      surgeon: latest.surgeon || "",
      surgical_procedure: latest.surgical_procedure || "",
      perioperative_analgesia_plan: latest.perioperative_analgesia_plan || "",
      preoperative: latest.preoperative || "",
      intraoperative: latest.intraoperative || "",
      postoperative: latest.postoperative || ""
    },
    rows: latest.assessment_rows?.map((row, index) => ({
      id: row.id || index + 1,
      assessment_time: row.assessment_time || "",
      pulse_rate: row.pulse_rate || "",
      blood_pressure: row.blood_pressure || "",
      respiratory_rate: row.respiratory_rate || "",
      spo2: row.spo2 || "",
      vas_score: row.vas_score || "",
      sedation: row.sedation || "",
      rescue_analgesia_given: row.rescue_analgesia_given || "",
      staff_nurse: row.staff_nurse || ""
    })) || [{
      id: 1,
      assessment_time: "",
      pulse_rate: "",
      blood_pressure: "",
      respiratory_rate: "",
      spo2: "",
      vas_score: "",
      sedation: "",
      rescue_analgesia_given: "",
      staff_nurse: ""
    }]
  };
};

export const mapFormToBackend = (patientData, rows) => {
  return {
    ...patientData,
    assessment_rows: rows.map(({ id, ...rest }) => rest)
  };
};
